export function headerFixed() {
	let header = document.querySelector(".header");
	let lastScrollTop = 0;

	function scrollHide() {
		let st = window.pageYOffset || document.documentElement.scrollTop;

		if (st === 0) {
			header.classList.remove("header--filled");
		} else if (st > lastScrollTop) {
			header.classList.add("header--hide");
			header.classList.remove("header--filled");
		} else {
			header.classList.add("header--filled");
			header.classList.remove("header--hide");
		}
		lastScrollTop = st <= 0 ? 0 : st;
	}

	window.addEventListener("scroll", () => {
		scrollHide();
	});
}
